const getCombinedParams = () => {
  if (typeof window === 'undefined') return new URLSearchParams();
  const hash = (window.location.hash || '').replace(/^#/, '');
  const combined = `${window.location.search || ''}&${hash}`;
  return new URLSearchParams(combined);
};

export const hasTgWebAppParam = () => {
  const params = getCombinedParams();
  return params.has('tgWebAppPlatform') || params.has('tgWebAppVersion') || params.has('tgWebAppData');
};

const hasValidInitData = (value) => {
  if (typeof value !== 'string' || !value.trim()) {
    return false;
  }
  return value.includes('hash=') && value.includes('auth_date=');
};

export const isTelegramMiniApp = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const params = getCombinedParams();
  if (params.get('miniapp') === '1' || hasTgWebAppParam()) {
    return true;
  }

  const telegram = window.Telegram?.WebApp;
  const initData = telegram?.initData || telegram?.initDataUnsafe;
  if (hasValidInitData(initData)) {
    return true;
  }

  return false;
};

export const shouldSendToTelegram = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    if (localStorage.getItem('telegram_miniapp') === '1') {
      return true;
    }
  } catch (err) {
    /* ignore */
  }
  const params = getCombinedParams();
  if (params.get('force_telegram') === '1') {
    return true;
  }
  if (params.get('miniapp') === '1' || hasTgWebAppParam()) {
    return true;
  }
  return isTelegramMiniApp();
};
